import { useMutation, useQueryClient } from "@tanstack/react-query";
import sDocumentAxios from "../../../../services/department-viags/statistic-documents.service";

interface Variables {
  parentId: number;
  info: { id: number; displayOrder: number }[];
}

const update = (params: Variables) => {
  const url = `/viagsemployee/update-display-order/${params.parentId}`;
  return sDocumentAxios.post(url, params.info);
};

export const useUpdateDisplayOrder = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (variables: Variables) => update(variables),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ["viags-departments"] });
  };

  return { ...mutation, invalidate };
};
